import React, { useState, useEffect } from 'react';

export default function TagManager() {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [saving, setSaving] = useState(false);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);

  const load = () => {
    setLoading(true);
    fetch('/api/tags', { credentials: 'include' })
      .then(r => r.json())
      .then(data => { setTags(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const startEdit = (tag) => { setEditingId(tag.id); setEditValue(tag.name); };
  const cancelEdit = () => { setEditingId(null); setEditValue(''); };

  const saveRename = async (tagId) => {
    if (!editValue.trim()) return;
    setSaving(true);
    await fetch(`/api/tags/${tagId}`, {
      method: 'PATCH', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: editValue.trim() })
    });
    setSaving(false);
    setEditingId(null);
    setEditValue('');
    load();
  };

  const handleDelete = async (tagId) => {
    await fetch(`/api/tags/${tagId}`, { method: 'DELETE', credentials: 'include' });
    setConfirmDeleteId(null);
    load();
  };

  if (loading) return <div className="inspire-container"><div className="spinner" /></div>;

  const confirmTag = tags.find(t => t.id === confirmDeleteId);

  return (
    <div style={{ maxWidth: 480 }}>
      <div className="page-header">
        <h1>Manage Tags</h1>
        <div className="subtitle">{tags.length} tag{tags.length !== 1 ? 's' : ''}</div>
      </div>

      {tags.length === 0 ? (
        <p style={{ color: 'var(--text-muted)', fontFamily: 'sans-serif', fontSize: '0.95rem' }}>No tags yet.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {tags.map(tag => (
            <div
              key={tag.id}
              style={{
                padding: '0.65rem 0.875rem', background: 'var(--surface)',
                border: '0.5px solid var(--border)', borderRadius: 'var(--radius)'
              }}
            >
              {editingId === tag.id ? (
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                  <input
                    className="search-input"
                    value={editValue}
                    onChange={e => setEditValue(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') saveRename(tag.id); if (e.key === 'Escape') cancelEdit(); }}
                    autoFocus
                    style={{ flex: 1, padding: '0.35rem 0.65rem', fontSize: '0.875rem' }}
                  />
                  <button
                    className="btn btn-primary"
                    onClick={() => saveRename(tag.id)}
                    disabled={saving || !editValue.trim()}
                    style={{ padding: '0.35rem 0.75rem', fontSize: '0.8rem', whiteSpace: 'nowrap' }}
                  >
                    {saving ? 'Saving…' : 'Save'}
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={cancelEdit}
                    style={{ padding: '0.35rem 0.75rem', fontSize: '0.8rem' }}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.5rem', marginBottom: '0.4rem' }}>
                    <span style={{ fontSize: '0.95rem', fontFamily: 'sans-serif', fontWeight: 500 }}>{tag.name}</span>
                    <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)', fontFamily: 'sans-serif' }}>
                      {tag.card_count} card{tag.card_count !== 1 ? 's' : ''}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button
                      className="btn btn-secondary"
                      onClick={() => startEdit(tag)}
                      style={{ padding: '0.3rem 0.65rem', fontSize: '0.8rem' }}
                    >
                      Rename
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() => setConfirmDeleteId(tag.id)}
                      style={{ padding: '0.3rem 0.65rem', fontSize: '0.8rem' }}
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      )}

      {confirmDeleteId !== null && confirmTag && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Delete "{confirmTag.name}"?</h3>
            <p>
              This will remove the tag from{' '}
              {confirmTag.card_count > 0
                ? `all ${confirmTag.card_count} card${confirmTag.card_count !== 1 ? 's' : ''} and delete it`
                : 'all cards and delete it'}.
            </p>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setConfirmDeleteId(null)}>Cancel</button>
              <button className="btn btn-danger" onClick={() => handleDelete(confirmDeleteId)}>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
